var Shopify = Shopify || {};
// Money format handler 
Shopify.money_format = document.querySelector('body').dataset.moneyFormat || "${{amount}}";

Shopify.formatMoney = function(cents, format) {
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == 0 || number == null) { return 0; }

    if(precision == 2){
      number = (number/100.0).toFixed(precision).replace('.', decimal);
      
      var parts   = number.split(decimal);
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents   = parts[1] ? (decimal + parts[1]) : '';
      
      return dollars + cents;
    }
    else{
      number = number.toString();
      var dollars = number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      
      return dollars;
    }
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      if (typeof cents == 'string') { 
        cents = cents.replace('.','');
      }
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      if (typeof cents == 'string') { 
        cents = cents.split('.')[0];
      }
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      if (typeof cents == 'string') { 
        cents = cents.replace('.','');
      }
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      if (typeof cents == 'string') { 
        cents = cents.split('.')[0];
      }
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      if (typeof cents == 'string') { 
        cents = cents.replace('.','');
      }
      value = formatWithDelimiters(cents, 2, '\'', '.');
    break;
  }

  return formatString.replace(placeholderRegex, value);
};

function copyCpnCode(element) {
    if (element.getAttribute('aria-busy') === 'true') return;
    const textEl = element.querySelector('.copy__text');
    if (!textEl) return;
    const originalText = element.querySelector('.copy__text').innerHTML;
    const copiedText = element.dataset.copied || 'Copied';
    const cpnCode = element.dataset.text || textEl.textContent;
    requestAnimationFrame(() => {
        textEl.textContent = copiedText;
        element.setAttribute('aria-busy', 'true'); 
    });
    setTimeout(() => {
        navigator.clipboard.writeText(cpnCode.trim())
            .then(() => {
            })
            .catch(err => console.error('Copy failed:', err));
    }, 0);
    if (element.copyTimer) clearTimeout(element.copyTimer);
    element.copyTimer = setTimeout(() => {
        requestAnimationFrame(() => {
            textEl.textContent = originalText;
            element.removeAttribute('aria-busy');
        });
    }, 2000); 
}

// Search Dropdown
class SearchDropdown extends HTMLElement {
    constructor() {
        super();

        this.dropdownToggle = this.querySelector('.search-dropdown-header-form');
        this.dropdownContents = this.querySelector('.search-dropdown-container');
        this.searchField = this.querySelector('input[type="search"]');
        this.dropdownClose = this.querySelector('.search-dropdown-close');

        this.searchField.addEventListener('click', (e) => {
            e.preventDefault();
            this.onClick(e)
        });
        this.dropdownClose.addEventListener('click', () => this.close())
        document.addEventListener('click', (event) => {
            if (event.target !== this && !this.contains(event.target)) {
                this.close()
            }
        })
    }

    onClick(e) {
        if( !this.classList.contains('active') ){
            this.open();

            setTimeout(() => {
                this.searchField.focus()
            }, 100);
        }
    }

    open() {
        this.classList.add('active');
    }

    close() {
        this.classList.remove('active');
    }
}
customElements.define('search-dropdown', SearchDropdown);

// Popup modal
class PopupModal extends HTMLElement{
    constructor(){
        super();

        this.cookieOnloadNature = this.dataset.popupOnload || 'notification';
        this.isDisableScroll = false;
        this.popupCloseButton = this.querySelector('.popup-modal__close');
        this.popupOverlay = this.querySelector('.popup-modal__overlay');

        if( this.cookieOnloadNature == 'verification' ){
            this.isDisableScroll = true;
        }

        if(this.popupCloseButton){
            this.popupCloseButton.addEventListener('click', () => {
                this.onClose();
            })
        }

        this.addEventListener('click', function(event) {
          if (event.target.matches('.installment_payment_close_btn')) {
            this.onClose();
          }
        })

        if(this.popupOverlay && this.cookieOnloadNature == 'notification'){
            this.popupOverlay.addEventListener('click', () => {
                this.onClose();
            })
        }

        if( this.dataset.popupType == 'onload' ){
            this.handleOnLoadPopup();
            this.sectionPopupClose = this.querySelector('.section-popup-button-close');

            if( this.sectionPopupClose ){
                this.sectionPopupClose.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.onClose();
                })
            }
        }
    }
    disableScroll = () => {
        if(!Shopify.designMode){
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100%';
        }
    }

    enableScroll = () => {
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('height');
    }

    onClose = () => {
        this.classList.add('inactive');
        this.classList.remove('quickview-modal');
        this.querySelector('.popup-modal__content').innerHTML = '';
        this.enableScroll();
    }

    handleOnLoadPopup = () => {
        this.style.display = null;
        var expireOn = parseInt(this.dataset.popupExpiry);
        var delay = this.dataset.popupDelay;
        var cookieName = this.dataset.popupCookieName;
        var frequency = 1;

        if( this.cookieOnloadNature == 'verification' ){
            var confirmBtn = this.querySelector('.confirm-button');
            if( confirmBtn ){
                confirmBtn.addEventListener('click', () => {
                    // Cookies.set(cookieName, true, { expires: expireOn, path: '/' });
                    this.onClose();
                })
            }
                
            if (Cookies.get(cookieName)) {
                this.onClose();
            }
            else {
                window.onload = setTimeout( () => {
                    this.classList.remove('inactive');
                    if(this.isDisableScroll){
                        this.disableScroll();
                    }
                }, delay )
            }
        }
        else if (this.cookieOnloadNature == 'notification'){

            var visits = 0;
            if( Cookies.get(cookieName) ){
                visits = Cookies.get(cookieName);
            }
            visits++;

            // Cookies.set(cookieName, visits, { expires: expireOn, path: '/' });

            if (Cookies.get(cookieName) > frequency) {
                this.onClose();
            }
            else {
                window.onload = setTimeout( () => {
                    this.classList.remove('inactive');
                    
                    if(this.isDisableScroll){
                        this.disableScroll();
                    }
                }, delay )
            }
        }
    }
}
customElements.define('popup-modal', PopupModal)

function AjaxProductUpdate(product, data){
    var cartCountElements = document.querySelectorAll('.cart-count');
    var cartDrawerSelector = '.cart-drawer-inner';

    // Count update
    for(let cart_count of cartCountElements){
        var totalCount = parseInt(data['quantity']);
        
        if(cart_count.textContent){
            totalCount = parseInt(cart_count.textContent) + parseInt(data['quantity'])
        }
        
        cart_count.textContent = totalCount
    }

    // Drawer update
    var cartDrawer = product.sections['cart-drawer'];
    var cartDrawerInnerDOM = new DOMParser().parseFromString(cartDrawer, 'text/html').querySelector(cartDrawerSelector);
    var cartDrawerInner = document.querySelector('.cart-drawer-inner');
    var mainCart = document.querySelector('.section-main-cart-container');
    let cartDrawerInfoText = cartDrawerInner?.querySelector('.cart-drawer__information_text');
    let freeShipping = cartDrawerInnerDOM.querySelector('.cart-drawer-free-shipping');

    if (freeShipping) {
        let freegift1 = freeShipping.dataset.minFree_1Id;
        let freegift2 = freeShipping.dataset.minFree_2Id;
        let cartTotal = parseInt(freeShipping.dataset.cartTotal);
        let minAmount1 = parseInt(freeShipping.dataset.minAmount);
        let minAmount2 = parseInt(freeShipping.dataset.minFree_2Amount);
        
        let updatesFreeGifts = {};
        
        // 获取当前购物车内已有的赠品情况
        const cartProducts = Array.from(document.querySelectorAll('.cart-product'));
        const hasGift1 = cartProducts.some(item => item.dataset.itemId == freegift1 && item.dataset.qty > 0);
        const hasGift2 = cartProducts.some(item => item.dataset.itemId == freegift2 && item.dataset.qty > 0);

        if (freegift2 && cartTotal >= minAmount2) {
            // --- 阶梯 2：满足最高门槛 ---
            if (!hasGift2) updatesFreeGifts[freegift2] = 1; // 添加礼品 2
            if (hasGift1) updatesFreeGifts[freegift1] = 0; // 移除礼品 1 (互斥核心)

        } else if (freegift1 && cartTotal >= minAmount1) {
            // --- 阶梯 1：仅满足第一门槛 ---
            if (!hasGift1) updatesFreeGifts[freegift1] = 1; // 添加礼品 1
            if (hasGift2) updatesFreeGifts[freegift2] = 0; // 移除礼品 2 (防止降级后礼品残留)

        } else {
            // --- 均不满足：清空所有赠品 ---
            if (hasGift1) updatesFreeGifts[freegift1] = 0;
            if (hasGift2) updatesFreeGifts[freegift2] = 0;
        }

        // 执行更新
        if (Object.keys(updatesFreeGifts).length > 0) {
            updateFreeGifts(updatesFreeGifts, cartDrawerInfoText);
        }
    }

    if (mainCart && product.sections?.['main-cart']) {
        let newCartContent = new DOMParser().parseFromString(product.sections['main-cart'], 'text/html').querySelector('.section-main-cart-container');
        mainCart.replaceWith(newCartContent);
    }
    if( cartDrawerInner ){
        if (cartDrawerInfoText) {
            // cartDrawerInnerDOM.querySelector('.cart-drawer-body').prepend(cartDrawerInfoText);
            cartDrawerInner.replaceWith(cartDrawerInnerDOM);
        }else{
            cartDrawerInner.replaceWith(cartDrawerInnerDOM);

        }
    }
    
    var cartProductUpsellSelector = '.cart-product-upsell';
    var cartProductUpsell = document.querySelector(cartProductUpsellSelector);
    
    if(cartProductUpsell){
        var cartUpsellItemId = cartProductUpsell.dataset.itemId
        var cartUpsellItemQty = parseInt(cartProductUpsell.querySelector('input[type="number"]').value)
        
        var itemQty = parseInt(data.quantity)

        var updates = {
            [cartUpsellItemId]: cartUpsellItemQty + itemQty
        }
        
        ChangeCartJson(updates);
    }
}

// Generic error message function
const showProductError = (container, message) => {
    if (!container) return;
    let errorEl = container.querySelector('.error');
    if (!errorEl) {
        errorEl = document.createElement('p');
        errorEl.classList.add('error');
        container.prepend(errorEl);
    }
    errorEl.innerHTML = message;
};

// Pre-sale pop-up rendering logic
const renderPreOrderPopup = (htmlContent) => {
    let popupModal = document.querySelector('popup-modal.product-pre_order-popup-modal');
    if (popupModal) {
        popupModal.classList.remove('inactive');
        popupModal.querySelector('.popup-modal__content').innerHTML = htmlContent;
        return;
    }

    const modalString = `
        <popup-modal class="popup-modal product-info-popup-modal product-pre_order-popup-modal">
            <div class="popup-modal__overlay"></div>
            <div class="popup-modal__inner">
                <div class="popup-modal__content">${htmlContent}</div>
                <button class="popup-modal__close">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="1.11092" y1="0.610962" x2="8.88909" y2="8.38914" stroke="currentColor" stroke-linecap="round"/>
                        <line x1="1.11096" y1="8.38915" x2="8.88914" y2="0.610971" stroke="currentColor" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
        </popup-modal>`;
    document.body.insertAdjacentHTML('beforeend', modalString);
};

const upsellModal = {
    getVariantId(el) { 
        return el.querySelector('select')?.value; 
    },
    
    open: function(form) {
        const el = form.querySelector('#AfterUpsellModal');
        
        if (!el) return Promise.resolve({ shouldAdd: false }); 

        el.classList.add('is-open');
        el.setAttribute('aria-hidden', 'false');

        return new Promise((resolve) => {
            const confirmBtn = el.querySelector('[data-upsell-confirm]');
            const declineEls = el.querySelectorAll('[data-upsell-decline]');
            
            const handleConfirm = () => {
                cleanup();
                resolve({ shouldAdd: true, variantId: this.getVariantId(el) });
            };

            const handleDecline = () => {
                cleanup();
                resolve({ shouldAdd: false });
            };

            const cleanup = () => {
                if (confirmBtn) confirmBtn.removeEventListener('click', handleConfirm);
                declineEls.forEach(btn => btn.removeEventListener('click', handleDecline));
                this.close(el); 
            };

            if (confirmBtn) confirmBtn.addEventListener('click', handleConfirm);
            declineEls.forEach(btn => btn.addEventListener('click', handleDecline));
        });
    },

    close: function(el) {
        if (!el) return;
        el.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
    }
};

// Product add to cart Ajax
document.body.addEventListener('click', async (event) => {
    const btn = event.target.closest('.product-add-to-cart');
    if (!btn || btn.hasAttribute('disabled') || btn.disabled) return;

    const form = event.target.closest('.product-options-form');
    if (!form) return;

    event.preventDefault();

    const summary = btn.closest('.product-summary');
    const summaryAction = summary?.querySelector('.product-summary__action') || btn.closest('.product');
    
    const formData = new FormData(form);
    const baseData = Object.fromEntries(formData.entries());
    
    // Init: JSON Payload
    const payload = {
        items: [],
        sections: 'cart-drawer,main-cart', 
        sections_url: window.location.pathname
    };

    // --- Inventory Quantity Verification ---
    if (summary) {
        const qtyInput = summary.querySelector('input[name="quantity"]');
        if (qtyInput && qtyInput.hasAttribute('max')) {
            const maxQty = parseInt(qtyInput.getAttribute('max'), 10);
            const reqQty = parseInt(baseData['quantity'] || 1, 10);
            
            if (reqQty > maxQty) {
                const title = summary.querySelector('.product-summary__title')?.innerText || '';
                const select = summary.querySelector('select');
                const variantName = select ? select.options[select.selectedIndex]?.textContent.trim() : '';
                const errorText = btn.dataset.textQtyError?.replace('%qty', `${maxQty} ${title} - ${variantName}`) || 'Exceeds available quantity';
                
                showProductError(summaryAction, errorText);
                return false;
            }
        }
    }

    // ---Gift Card (Recipient Form) Validation---
    const recipientForm = summary?.querySelector('.recipient-form');
    const isRecipientFormEnabled = summary?.querySelector('.recipient-form-toggle input')?.checked;
    if (recipientForm && isRecipientFormEnabled) {
        const errors = [];
        const inputs = recipientForm.querySelectorAll('.recipient-form-fields--field.required');

        inputs.forEach(input => {
            if (input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
                errors.push('Enter a valid email address');
            }
            if (input.type === 'date' && input.value) {
                const daysDiff = Math.ceil((new Date(input.value) - new Date()) / (1000 * 3600 * 24));
                if (daysDiff < 0 || daysDiff > 90) {
                    errors.push('Enter a valid date (not longer than 90 days from now)');
                }
            }
        });

        if (errors.length > 0) {
            const errorContainer = recipientForm.querySelector('.recipient-form-errors');
            if (errorContainer) errorContainer.innerHTML = errors.map(err => `<li>${err}</li>`).join("");
            return false;
        }
    }

    // --- Construct the JSON Payload Items array ---
    let hasComplexItems = false;
    
    // Scan Addons
    const addons = summary?.querySelectorAll('product-addon') || [];
    addons.forEach(addon => {
        const checkbox = addon.shadowRoot?.querySelector('input[type="checkbox"]');
        if (checkbox?.checked) {
            hasComplexItems = true;
            let properties = {};
            try {
                properties = JSON.parse((addon.getAttribute('item-properties') || "{}").replace(/'/g, '"'));
            } catch (e) {}

            payload.items.push({
                id: parseInt(addon.shadowRoot.querySelector('.product-addons__item-selector').value, 10),
                quantity: 1,
                properties,
                parent_id: addon.getAttribute('item-child') === 'true' ? baseData.id : null
            });
        }
    });

    // Scan Child Keys
    const childKeys = Array.from(formData.keys()).filter(key => key.startsWith('children_id_'));
    if (childKeys.length > 0) {
        hasComplexItems = true;
        childKeys.forEach(key => {
            const childId = formData.get(key);
            if (childId) {
                payload.items.push({
                    id: parseInt(childId, 10),
                    quantity: 1,
                    parent_id: baseData.id
                });
            }
        });
    }

    const mainItemProperties = {};
    Object.keys(baseData).forEach(key => {
        if (key.startsWith('properties[')) {
            const propName = key.match(/properties\[(.*?)\]/)[1];
            if(propName) mainItemProperties[propName] = baseData[key];
        }
    });

    // Assemble the final structure
    if (hasComplexItems) {
        // If there are accessories, insert the main item at the beginning of the array.
        payload.items.unshift({
            id: parseInt(baseData.id, 10),
            quantity: parseInt(baseData.quantity || 1, 10),
            ...(Object.keys(mainItemProperties).length > 0 && { properties: mainItemProperties })
        });
        if (addons.length > 0) {
            payload.note = 'Addons';
        }
    } else {
        // If it is a regular single item being added to the cart, directly extract the basic form data.
        const mainItem = {
            id: parseInt(baseData.id, 10),
            quantity: parseInt(baseData.quantity || 1, 10),
        };
        
        if (Object.keys(mainItemProperties).length > 0) {
            mainItem.properties = mainItemProperties;
        }
        
        payload.items.push(mainItem);
    }

    const isQuickview = !!btn.closest('popup-modal');
    const hasUpsellModal = !!form.querySelector('#AfterUpsellModal');
    
    if (hasUpsellModal && !isQuickview) {
        btn.setAttribute('disabled', 'disabled'); 
        btn.classList.add('loading'); 

        // Pause execution and wait for the user to make a selection in the pop-up window. 
        const userChoice = await upsellModal.open(form);

        // If the user confirms adding the recommended item, merge it into the payload.
        if (userChoice.shouldAdd && userChoice.variantId) {
            payload.items.push({
                id: parseInt(userChoice.variantId, 10),
                quantity: 1,
                properties: { '_after_upsell_from': baseData.id },
                parent_id: baseData.id// MARK
            });
            // payload.note = payload.note ? payload.note + ', With Upsell' : 'With Upsell';
        }
    }

    // --- Post ---
    btn.setAttribute('disabled', 'disabled'); 
    btn.classList.add('loading'); 

    try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json' 
            },
            body: JSON.stringify(payload)
        });

        const res = await response.json();

        if (!response.ok || res.status === 422) {
            showProductError(summaryAction, res.description || 'Unable to add to cart.');
            return false;
        }

        //UI Update
        if (typeof AjaxProductUpdate === 'function') AjaxProductUpdate(res, baseData);

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            document.querySelector('.section-header-cart-drawer-toggle')?.click();
        }

        const popupModal = document.querySelector('popup-modal:not(.product-pre_order-popup-modal)');
        if (popupModal) {
            popupModal.classList.add('inactive');
            popupModal.querySelector('.popup-modal__content').innerHTML = '';
        }

        const preOrderHtml = btn.dataset.preOrderPopupHtml;
        if (preOrderHtml) {
            renderPreOrderPopup(preOrderHtml);
        }

    } catch (error) {
        console.error('Cart Add Error:', error);
        showProductError(summaryAction, 'An error occurred while adding to cart. Please try again.');
    } finally {
        btn.removeAttribute('disabled');
        btn.classList.remove('loading');
    }
});

// Before/After image
class BeforeAfter extends HTMLElement{
    constructor(){
        super();

        this.beforeAfterHandle = this.querySelector('.before-after-handler');
        this.beforeAfterHandleButton = this.querySelector('.before-after-handler-button');

        this.mouseOnClickElement = false;

        this.beforeAfterHandleButton.addEventListener('mousedown', () => { this.mouseOnClickElement = true; })
        this.beforeAfterHandleButton.addEventListener('touchstart', () => { this.mouseOnClickElement = true; })

        document.addEventListener('mouseup', () => { this.mouseOnClickElement = false; })
        document.addEventListener('touchend', () => { this.mouseOnClickElement = false; })

        this.addEventListener('mousemove', (event) => this.onMouseMove(event));
        this.addEventListener('touchmove', (event) => this.onMouseMove(event));
    }

    onMouseMove = (event) =>  {
        var type = event.type;
        var pageX = event.pageX;

        if (type === "touchmove") {
            var touch = event.touches[0] || event.changedTouches[0];
            pageX = touch.pageX;
        }

        var offsetWidth = this.getBoundingClientRect().width;
        var offsetLeft = this.getBoundingClientRect().left;

        if(this.mouseOnClickElement){
            var offsetX = (((pageX - offsetLeft) * 100) / (offsetWidth)).toFixed(2)
            if(offsetX < 100 && offsetX > 0){
                this.style.setProperty('--handler-offset', offsetX + '%');
            }
        }
    }
}
customElements.define('before-after', BeforeAfter);

// Collapsible row
class CollapsibleRow extends HTMLElement{
    constructor(){
        super();
        this.detectDefaultTab();
        this.querySelector('.collapsible-row__title').addEventListener('click', () => {
            this.onClick();
        })
    }

    detectDefaultTab = () => {
        if( this.classList.contains('active_by_default') ){
            const collapsibleContent = this.querySelector('.collapsible-row__content');
            const collapsibleContentHeight = collapsibleContent.offsetHeight;
            collapsibleContent.style.height = collapsibleContentHeight + 'px';
            this.classList.add('active'); 
            this.classList.remove('active_by_default');
        }   
    }
    
    closeCollapsible = (element) => {
        if (element.classList.contains('active')) {
            const content = element.querySelector('.collapsible-row__content');
            content.style.removeProperty('height');
            setTimeout(() => {
                element.classList.remove('active');
            }, 200);
        }
    }

    onClick = () => {
        const siblings = Array.from(this.parentElement.querySelectorAll('collapsible-row'))
            .filter(sibling => sibling !== this);

        siblings.forEach(sibling => {
            this.closeCollapsible(sibling);
        });

        const collapsibleContent = this.querySelector('.collapsible-row__content');
        const collapsibleContentHeight = collapsibleContent.offsetHeight;

        if( this.classList.contains('active') ){
            collapsibleContent.style.removeProperty('height');
            setTimeout(() => {
                this.classList.remove('active');
            }, 200);
        } else {
            this.classList.add('active');
            setTimeout(() => {
                collapsibleContent.style.height = collapsibleContentHeight + 'px';
            }, 10);
        }
    }
}
customElements.define('collapsible-row', CollapsibleRow)

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.timeinterval = null;
    this.isStopping = false; 
    this.enddate = this._parseEndDate();
  }
  
  _parseEndDate() {
    const raw = this.dataset.countdownEnddate || this.dataset.endtime;
    if (!raw) return null;

    let date;
    
    if (/^\d+$/.test(raw.trim())) {
      date = new Date(Number(raw) * 1000);
    } else {
      date = new Date(raw);
    }

    return isNaN(date.getTime()) ? null : date;
  }

  init() {
    if (!this.enddate) {
      console.warn('Countdown: Invalid or missing end date.');
      return;
    }

    this.updateCountdown();

    if (this.enddate > new Date()) {
      const countdownExpireMessage = this.querySelector('.countdown-message');
      if (countdownExpireMessage) countdownExpireMessage.classList.add('hide');
      
      this.timeinterval = setInterval(() => this.updateCountdown(), 1000);
    } else {
      this.handleExpiration();
    }
  }

  getTimeRemaining() {
    const t = this.enddate.getTime() - Date.now();
    const total = Math.max(0, t); 
    
    return {
      total,
      days: Math.floor(total / (1000 * 60 * 60 * 24)),
      hours: Math.floor((total / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((total / 1000 / 60) % 60),
      seconds: Math.floor((total / 1000) % 60)
    };
  }

  updateCountdown = () => {
    const t = this.getTimeRemaining();
    
    const elements = {
      days: this.querySelector('.days'),
      hours: this.querySelector('.hours'),
      minutes: this.querySelector('.minutes'),
      seconds: this.querySelector('.seconds'),
      daysContainer: this.querySelector('.countdown-holder--days')
    };

    if (elements.days) elements.days.textContent = t.days;
    if (elements.hours) elements.hours.textContent = String(t.hours).padStart(2, '0');
    if (elements.minutes) elements.minutes.textContent = String(t.minutes).padStart(2, '0');
    if (elements.seconds) elements.seconds.textContent = String(t.seconds).padStart(2, '0');

    if (elements.daysContainer) {
      elements.daysContainer.style.display = t.days === 0 ? 'none' : '';
    }

    if (t.total <= 0) {
      this.handleExpiration();
    }
  };

  handleExpiration() {
    this.stop(true); 

    const countdownHolder = this.querySelector('.countdown-holder');
    if (countdownHolder) countdownHolder.remove();

    const countdownExpireMessage = this.querySelector('.countdown-message');
    if (countdownExpireMessage) {
      countdownExpireMessage.classList.remove('hide');
    }
  }

  /**
   * Stop timing and clean up the environment
   * @param {boolean} clearServer - Synchronize and clear Shopify Cart Attribute
   */
  stop(clearServer = false) {
    if (this.isStopping) return;
    this.isStopping = true;

    if (this.timeinterval) {
      clearInterval(this.timeinterval);
      this.timeinterval = null;
    }

    const discountIncentiveInner = this.closest('.discount_incentive_inner');
    if (discountIncentiveInner) {
      discountIncentiveInner.classList.remove('active');
    }

    if (clearServer) {
      this.clearShopifyAttribute();
    }

    this.remove();
  }

  async clearShopifyAttribute() {
    try {
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { discountIncentiveEndTime: '' }
        })
      });
    } catch (error) {
      console.error('Countdown: Failed to update Shopify cart attributes', error);
    }
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.timeinterval) {
      clearInterval(this.timeinterval);
    }
  }
}
if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', Countdown);
}

if (!customElements.get('card-default-variant-picker')) {
    class CardDefaultVariantPicker extends HTMLElement {
        constructor() {
            super();
            this.container = this.closest('.product');
            this.allVariantsSelect = this.querySelector('.product__all_variant');
            this.productFormInput = this.container.querySelector('input[name="id"]');
            this.productMedia = this.container.querySelector('.feature-img')
            
            this.initEventListeners();
        }

        connectedCallback() {
            this.syncSelectedVariant();
        }

        initEventListeners() {
            this.addEventListener('change', (event) => {
                if (event.target.matches('input[type="radio"], .variant-option__select')) {
                    this.syncSelectedVariant();
                }
            });
        }

        getCurrentOptionsMap() {
            const selectedMap = {};
            this.querySelectorAll('.cdvp_variant-options').forEach(fieldset => {
                const index = fieldset.dataset.optionIndex;
                const radioSelected = fieldset.querySelector('input[type="radio"]:checked');
                const selectSelected = fieldset.querySelector('select');

                if (radioSelected) {
                    selectedMap[index] = radioSelected.value.trim();
                } else if (selectSelected) {
                    selectedMap[index] = selectSelected.value.trim();
                }
            });
            return selectedMap;
        }

        syncSelectedVariant() {
            const selectedMap = this.getCurrentOptionsMap();
            const allOptions = Array.from(this.allVariantsSelect.options);
            
            const matchedOption = allOptions.find(option => {
                return Object.keys(selectedMap).every(index => {
                    const attrName = `option${parseInt(index) + 1}`;
                    const variantValue = option.dataset[attrName];
                    return variantValue === selectedMap[index];
                });
            });

            if (matchedOption) {
                this.updateUI(matchedOption);
            }
        }

        generateSrcset(image) {
            const widths = this.productMedia.getAttribute('data-widths').split(',').map((width) => parseInt(width));
            return widths.map((width) => {
            return `${image}&width=${width} ${width}w`;
            }).join(', ');
        }

        updateUI(matchedOption) {
            const variantId = matchedOption.value;

            if (this.productFormInput) this.productFormInput.value = variantId;
            this.allVariantsSelect.value = variantId;

            const priceContainer = this.container.querySelector('.product__price');
            if (priceContainer && matchedOption.dataset.priceHtml) {
                priceContainer.innerHTML = matchedOption.dataset.priceHtml;
            }

            const labelContainer = this.container.querySelector('.product__top > .product__labels');
            if (labelContainer && matchedOption.dataset.badge_arry) {
                labelContainer.innerHTML = new DOMParser().parseFromString(matchedOption.dataset.badge_arry, 'text/html').body.innerHTML;
            }

            this.productMedia.src = matchedOption.dataset.variantImage;
            this.productMedia.srcset = this.generateSrcset(matchedOption.dataset.variantImage);

            const addToCartBtn = this.container.querySelector('.product-add-to-cart');
            if (addToCartBtn) {
                const isAvailable = matchedOption.dataset.available === "true";
                addToCartBtn.disabled = !isAvailable;

                if (matchedOption.dataset.preOrderPopupHtml) {
                    addToCartBtn.dataset.preOrderPopupHtml = matchedOption.dataset.preOrderPopupHtml;
                }
                
                const btnText = addToCartBtn.querySelector('.text');
                if (btnText) {
                    btnText.innerText = matchedOption.dataset.ctaText || '';
                }
            }

            this.dispatchEvent(new CustomEvent('variant:change', {
                bubbles: true,
                detail: { variant: matchedOption }
            }));
        }
    }
    customElements.define('card-default-variant-picker', CardDefaultVariantPicker);
}

document.addEventListener('DOMContentLoaded', () => {
    // Back to top
    const backToTop = document.querySelector('.back-to-top');

    if (backToTop) {
        let throttleTimeout = null;
        window.addEventListener('scroll', () => {
            if (throttleTimeout) return;

            throttleTimeout = setTimeout(() => {
                const shouldShow = window.scrollY > window.innerHeight;
                backToTop.classList.toggle('active', shouldShow);
                
                throttleTimeout = null;
            }, 100);
        });

        backToTop.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
    document.addEventListener('click', (e) => {
        // Quickview
        if( e.target.closest('.product-quickview') ){
            var productQuickview = e.target.closest('.product-quickview'); 
            var handle = productQuickview.dataset.handle
            productQuickview.classList.add('loading');

            var popupModal = document.querySelector('.popup-modal-quickview');

            if( !popupModal ){
                var quickviewModalString = `<popup-modal class="popup-modal popup-modal-quickview">
                <div class="popup-modal__overlay"></div>
                <div class="popup-modal__inner">
                    <div class="popup-modal__content quickview-popup-model__content">
                    </div>
                    <button class="popup-modal__close">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="1.11092" y1="0.610962" x2="8.88909" y2="8.38914" stroke="currentColor" stroke-linecap="round"/>
                            <line x1="1.11096" y1="8.38915" x2="8.88914" y2="0.610971" stroke="currentColor" stroke-linecap="round"/>
                        </svg>
                    </button>
                </div>
                </popup-modal>
                            `
                var quickviewModal = new DOMParser().parseFromString(quickviewModalString, 'text/html').querySelector('popup-modal')
                document.body.append(quickviewModal);
            }
            else{
                popupModal.classList.remove('inactive');
                popupModal.classList.remove('section-popup');
                popupModal.classList.add('quickview-modal');
            }

            fetch(`${window.Shopify.routes.root}products/${handle}?view=quickview`)
                .then((response) => {
                    if (!response.ok) {
                        var error = new Error(response.status);
                        throw error;
                    }
                    return response.text();
                })
                .then((res) => {

                    productQuickview.classList.remove('loading');

                    // var html = new DOMParser().parseFromString(res, 'text/html').querySelector('.shopify-section');
                    var html = new DOMParser().parseFromString(res, 'text/html').querySelector('.main-product');
                    
                    html.classList.add('quickview-product')
                    html.classList.remove('main-product');

                    var productInfoButtons = html.querySelectorAll('.product-info-popup__button');
                    for( let productInfoButton of productInfoButtons ){
                        productInfoButton.setAttribute('target', '_blank');
                    }

                    var popupModalContent = document.querySelector('.quickview-popup-model__content');
                    popupModalContent.innerHTML = '';
                    popupModalContent.append(html);

                    if (window.Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                    }
                    
                    var quickviewPopup = document.querySelector('body .popup-modal-quickview');
                    quickviewPopup.querySelector('a[href]').focus();
                    var popupClose = quickviewPopup.querySelector('.popup-modal__close');
                    if( popupClose ){
                        popupClose.addEventListener('keyup', (event) => {
                            // e.preventDefault();
                            if (event.key === 'Enter') {
                                productQuickview.closest('.product').querySelector('a[href]').focus();
                            }
                        })
                    }

                    document.addEventListener('keyup', (event) => {
                        if(event.key === 'Escape'){
                            quickviewPopup.classList.add('inactive');
                            quickviewPopup.classList.remove('quickview-modal');
                            
                            quickviewPopup.querySelector('.popup-modal__content').innerHTML = '';

                            productQuickview.closest('.product').querySelector('a[href]').focus();
                        }
                    })
                })
                .catch((error) => {
                    throw error;
                });
        }

    })
    if (!customElements.get('e-swiper')) {
        class ESwiper extends HTMLElement {
            constructor() {
                super();
            }
            connectedCallback() {
                const sectionId = this.getAttribute('section-id');
                this.section = sectionId ? document.getElementById(sectionId) : null;
                this.observerEl = this.section || this;

                const dataOptions = this.querySelector('.swiper').dataset.options;
                if (dataOptions) {
                this.options = JSON.parse(dataOptions);
                } else {
                this.options = {};
                }
                this.options.observer = true;
                this.options.observeParents = true;
                this.options.observeSlideChildren = true;
                
                if(this.querySelector('.splide__progress')){
                this.options.pagination = {
                    el: this.querySelector('.splide__progress'),
                    type: 'progressbar',
                };
                }

                if(this.querySelector('.splide__arrow')){
                this.options.navigation = {
                    nextEl: this.querySelector('.splide__arrow--next'),
                    prevEl: this.querySelector('.splide__arrow--prev'),
                };
                }

                this.directInit = this.hasAttribute('direct-init');
                if (this.directInit) {
                this.init();
                } else {
                this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
                    rootMargin: '100px',
                });
                this.observer.observe(this.observerEl);
                }
            }

            handleIntersection(entries) {
                entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.init();
                    this.observer.unobserve(this.observerEl);
                }
                });
            }

            init() {
                if (this.swiper) return;

                const swiperEl = this.querySelector('.swiper');
                if (swiperEl) {
                    setTimeout(() => {
                        requestAnimationFrame(() => {this.swiper = new Swiper(swiperEl, this.options)});

                        window.addEventListener('resize', () => {
                            if (this.swiper) {
                                this.swiper.update(); 
                            }
                        });
                    },5)
                }
            }
        }
        customElements.define('e-swiper', ESwiper);
    }
    if (!customElements.get('video-slide-section')) {
        class VideoSlideSection extends HTMLElement {
            constructor() {
            super(); 
            this.videoSlideArray = [];
            this.mutedBtnArray = [];
            this.observer = null; 
            }
        
            connectedCallback() {
            this._initDomReferences();
            this._bindVideoClickEvents();
            this._bindMutedBtnEvents();
            this._initIntersectionObserver();
            }
        
            disconnectedCallback() {
            if (this.observer) {
                this.observer.disconnect();
            }
            this._removeEventListeners();
            }
        
            _initDomReferences() {
            this.videoSlideArray = Array.from(this.querySelectorAll('.click-to-play'));
            this.mutedBtnArray = Array.from(this.querySelectorAll('.muted_btn'));
            }
        
            _bindVideoClickEvents() {
            this.videoSlideArray.forEach(container => {
                const handleClick = () => {
                const currentVideo = container.querySelector('video');
                const currentImg = container.querySelector('img');
        
                if (!currentVideo) return;
        
                container.classList.toggle('active');
        
                if (container.classList.contains('active')) {
                    this.videoSlideArray.forEach(item => {
                    if (item !== container) {
                        item.classList.remove('active');
                        const video = item.querySelector('video');
                        video?.pause();
                    }
                    });
        
                    currentImg?.style.setProperty('display', 'none');
                    currentVideo.play().catch(error => {
                    console.error('error:', error);
                    });
                } else {
                    currentVideo.pause();
                }
                };
        
                container.addEventListener('click', handleClick);
                container._videoClickHandler = handleClick; 
            });
            }
        
            _bindMutedBtnEvents() {
            this.mutedBtnArray.forEach(btn => {
                const handleMuted = (e) => {
                e.preventDefault();
                e.stopPropagation(); 
        
                btn.classList.toggle('on');
                const video = btn.closest('.media_video')?.querySelector('video');
                if (video) {
                    video.muted = !btn.classList.contains('on');
                }
                };
        
                btn.addEventListener('click', handleMuted);
                btn._mutedClickHandler = handleMuted;
            });
            }
        
            _initIntersectionObserver() {
            if (this.videoSlideArray.length === 0) return;
        
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const firstVideoSlide = this.videoSlideArray[0];
                    const img = firstVideoSlide.querySelector('img');
                    const video = firstVideoSlide.querySelector('video');
        
                    firstVideoSlide.classList.add('active');
                    img?.style.setProperty('display', 'none');
                    video?.play().catch(error => {
                    console.error('error:', error);
                    });
        
                    this.observer.unobserve(entry.target);
                }
                });
            }, { threshold: 0.5 }); 
        
            this.observer.observe(this);
            }
        
            _removeEventListeners() {
            this.videoSlideArray.forEach(container => {
                if (container._videoClickHandler) {
                container.removeEventListener('click', container._videoClickHandler);
                delete container._videoClickHandler; 
                }
            });
        
            this.mutedBtnArray.forEach(btn => {
                if (btn._mutedClickHandler) {
                btn.removeEventListener('click', btn._mutedClickHandler);
                delete btn._mutedClickHandler;
                }
            });
            }
        }
        customElements.define('video-slide-section', VideoSlideSection);  
    }
    if (!customElements.get('pillar-before-after')) {
        class PillarBeforeAfter extends HTMLElement {
            constructor() {
                super();
                this.tapList = null;
                this.imgList = null;
            }

            connectedCallback() {
                this.tapList = this.querySelectorAll('.tap__item');
                this.imgList = this.querySelectorAll('.blcok__item');
                
                this.bindTapClick();
                this.bindImgClick();
            }

            bindTapClick() {
                this.tapList.forEach((item, index) => {
                item.addEventListener('click', () => {
                    this.tapList.forEach(c => c.classList.remove('active'));
                    this.imgList.forEach(c => c.classList.remove('active'));
                    item.classList.add('active');
                    if (this.imgList[index]) {
                    this.imgList[index].classList.add('active');
                    }
                    this.handleReplaceConent(item);
                });
                });
            }

            bindImgClick() {
                this.imgList.forEach((item, index) => {
                item.addEventListener('click', () => {
                    this.tapList.forEach(c => c.classList.remove('active'));
                    this.imgList.forEach(c => c.classList.remove('active'));
                    item.classList.add('active');
                    if (this.tapList[index]) {
                    this.tapList[index].classList.add('active');
                    }
                    this.handleReplaceConent(item);
                });
                });
            }

            handleReplaceConent(target) {
                const data = {
                imgBefore: target.dataset.imgBefore,
                before: target.dataset.before,
                imgAfter: target.dataset.imgAfter,
                after: target.dataset.after,
                text1: target.dataset["text-1"],
                text2: target.dataset["text-2"],
                text3: target.dataset["text-3"],
                text4: target.dataset["text-4"]
                };

                this.querySelectorAll('.text_1').forEach(item => {
                item.innerHTML = data.text1;
                });
                if(this.querySelector('.text_2_wrapper'))this.querySelector('.text_2_wrapper').innerHTML = data.text2;
                if(this.querySelector('.text_3'))this.querySelector('.text_3').innerHTML = data.text3;
                if(this.querySelector('.text_4_wrapper'))this.querySelector('.text_4_wrapper').innerHTML = data.text4;
                if(this.querySelector('.before-image__heading'))this.querySelector('.before-image__heading').innerText = data.before;
                if(this.querySelector('.after-image__heading'))this.querySelector('.after-image__heading').innerText = data.after;
                if(this.querySelector('.before-image'))this.querySelector('.before-image').src = data.imgBefore;
                if(this.querySelector('.after-image'))this.querySelector('.after-image').src = data.imgAfter;
            }
        }
        customElements.define('pillar-before-after', PillarBeforeAfter);
    }
    if (!customElements.get('bundle-variant-picker')) {
        class BundleVariantPicker extends HTMLElement {
          constructor() {
            super();
            this.container = this.closest('.product');
            // this.swatchVariantImages = this.container.querySelectorAll('.product-swatches-variant-images-variant-image');
            this.allVariantsSelect = this.querySelector('.product__all_variant');
            this.customSelects = this.querySelectorAll('.product__option_picker_wrapper > .custom-select');
            this.productFormInput = this.container.querySelector('input[name="id"]');
            this.productMedia = this.container.querySelector('.feature-img')
            this.initEventListeners();
          }

          connectedCallback() {
            this.syncSelectedVariant();
          }

          initEventListeners() {
            this.customSelects.forEach(customSelect => {
              const trigger = customSelect.querySelector('.custom-select__trigger');
              const optionsList = customSelect.querySelector('.custom-select__options');
              const options = customSelect.querySelectorAll('.custom-select__option');

              trigger.addEventListener('click', (e) => {
                e.stopPropagation(); 
                optionsList.classList.toggle('hidden');
                this.customSelects.forEach(otherSelect => {
                  if (otherSelect !== customSelect) {
                    otherSelect.querySelector('.custom-select__options').classList.add('hidden');
                  }
                });
              });
              options.forEach(option => {
                option.addEventListener('click', () => {
                  options.forEach(opt => opt.removeAttribute('data-selected'));
                  option.setAttribute('data-selected', 'true');

                  const selectedValue = option.dataset.value;
                  const selectedColor = option.dataset.color;
                  const label = trigger.querySelector('.custom-select__label').textContent;
                  
                  let triggerHTML = `<span class="custom-select__label">${label}</span>`;
                  if (selectedColor) {
                    triggerHTML += `<span class="custom-select__option-swatch relative" style='--bg:${selectedColor}'></span>`;
                  }
                  triggerHTML += `<span class="custom-select__value desktop_show">${selectedValue}</span>`;
                  triggerHTML += `<svg class="absolute" width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.353516 0.353516L4.35352 4.35352L8.35352 0.353516" stroke="black"/></svg>`;
                  trigger.innerHTML = triggerHTML;
                  optionsList.classList.add('hidden');

                  this.syncSelectedVariant();
                });
              });
            });

            document.addEventListener('click', () => {
              this.customSelects.forEach(customSelect => {
                customSelect.querySelector('.custom-select__options').classList.add('hidden');
              });
            });
          }

          generateSrcset(image) {
                const widths = this.productMedia.getAttribute('data-widths').split(',').map((width) => parseInt(width));
                return widths.map((width) => {
                return `${image}&width=${width} ${width}w`;
                }).join(', ');
            }

          syncSelectedVariant() {
            const selectedValues = Array.from(this.customSelects).map(customSelect => {
              const selectedOption = customSelect.querySelector('.custom-select__option[data-selected="true"]');
              return selectedOption ? selectedOption.dataset.value.trim() : '';
            });

            const allOptions = Array.from(this.allVariantsSelect.options);
            const matchedOption = allOptions.find(option => {
              const variantValues = option.text.trim().split('/').map(v => v.trim());
              return selectedValues.every((value, index) => {
                return variantValues[index] === value;
              });
            });

            if (matchedOption) {
              this.allVariantsSelect.value = matchedOption.value;
              this.productFormInput.value = matchedOption.value; 

              if (this.container.querySelector('.product__top>.product__labels')) {
                this.container.querySelector('.product__top>.product__labels').innerHTML=matchedOption.dataset.badge_arry;
              }

            this.productMedia.src = matchedOption.dataset.variantImage;
            this.productMedia.srcset = this.generateSrcset(matchedOption.dataset.variantImage);

              this.container.querySelector('.product__price').innerHTML = matchedOption.dataset.priceHtml;
              this.container.querySelector('.product-add-to-cart>.text').innerText = matchedOption.dataset.ctaText || '';
              if(matchedOption.dataset.available == "true"){
                this.container.querySelector('.product-add-to-cart').disabled = false;
              } else {
                this.container.querySelector('.product-add-to-cart').disabled = true;
              }

              this.allVariantsSelect.dispatchEvent(new Event('change', {
                bubbles: true,
                cancelable: true
              }));
            }
          }

        }
        customElements.define('bundle-variant-picker', BundleVariantPicker);
    }
    if (!customElements.get('localization-form')) {
        class LocalizationForm extends HTMLElement {
            constructor() {
            super();
            this.elements = {
                input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
                button: this.querySelector('button.disclosure__button'),
                panel: this.querySelector('ul.disclosure__list'),
            };

            if (!this.elements.input || !this.elements.button || !this.elements.panel) return;
                this.elements.button.addEventListener('click', this.openSelector.bind(this));
                this.addEventListener('focusout', this.onFocusOut.bind(this));
                this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
                this.addEventListener('click', (event) => {
                    const optionButton = event.target.closest('.disclosure__option');
                    if (optionButton) {
                    this.onItemClick(event, optionButton);
                    }
                });
            }
            onFocusOut(event) {
            const isFocusInComponent = this.contains(event.relatedTarget);
            if (!isFocusInComponent) {
                this.hidePanel();
            }
            }
            hidePanel() {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', true);
            }
            openSelector(event) {
            const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
            this.elements.button.setAttribute('aria-expanded', !isExpanded);
            this.elements.panel.toggleAttribute('hidden');
            if (!isExpanded) {
                this.elements.button.focus();
            }
            }
            onContainerKeyUp(event) {
            if (event.code.toUpperCase() !== 'ESCAPE') return;
            this.hidePanel();
            this.elements.button.focus();
            }
            onItemClick(event, optionButton) {
            event.preventDefault();
            const form = this.querySelector('form');
            if (!form) return;
            this.elements.input.value = optionButton.dataset.value;
            this.hidePanel();
            fetch(window.Shopify.routes.root + 'cart/clear.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                },
            })
            .then(() => {
                form.submit();
            })
            .catch(error => {
                console.error('Clear cart error:', error);
                form.submit();
            });
            }
        }
        customElements.define('localization-form', LocalizationForm);
    }
})